export default __webpack_public_path__ + "static/media/DAIF_Services_In.88e18fe8.mp4";